
$(document).ready(function() {
    $('form').on('submit', function (event) {
        let firstFailingField = null;
        for (let i = 0; i < this.elements.length; i++) {
            let fieldIfFailed = updateFieldValidation(this.elements[i]);
            firstFailingField = firstFailingField !== null ? firstFailingField : fieldIfFailed;
        }
        if (firstFailingField !== null) {
            firstFailingField.focus();
            event.preventDefault();
            return false;
        }
        return true;
    });

    $('.form-control').on('blur', function (event) {
        event.preventDefault();
        updateFieldValidation(this);
    });

    $('.tel-input').mask('(000) 000-0000');

    function updateFieldValidation(formElement) {
        if (formElement.type === 'hidden' || formElement.type === 'submit') {
            return null;
        }
        let pattern = $(formElement).attr('data-pattern');
        let rx = (pattern !== null && pattern !== '') ? new RegExp(pattern) : null;
        let failedField = null;
        let fieldValue = $(formElement).val().trim();
        if (($(formElement).attr('data-required') === 'true' && fieldValue === '')
            || ((pattern !== null && pattern !== '' && rx !== null && fieldValue !== null && fieldValue !== '') && !rx.test(fieldValue))) {
            $(formElement).addClass('form-control-danger');
            $(formElement).closest('.form-group').addClass('has-danger');
            $(formElement).siblings('.form-control-feedback').show();
            failedField = formElement;
        } else {
            $(formElement).removeClass('form-control-danger');
            $(formElement).closest('.form-group').removeClass('has-danger');
            $(formElement).siblings('.form-control-feedback').hide();
        }
        if (failedField === null && fieldValue !== "") {
            $(formElement).addClass('form-control-success');
            $(formElement).closest('.form-group').addClass('has-success');
            $(formElement).siblings('.form-control-feedback').hide();
        }
        return failedField;
    }

    /* Alerts */
    $('.return-home-alert').on('closed.bs.alert', function () {
        window.location.replace('../');
    });
});



// WEBPACK FOOTER //
// ./src/_assets/js/form-validation.js